"use strict";

exports.cosine = require('./similarities/cosine');
exports.czekanowski = require('./similarities/czekanowski');
exports.dice = require('./similarities/dice');
exports.intersection = require('./similarities/intersection');
exports.jaccard = require('./similarities/jaccard');
exports.kulczynski = require('./similarities/kulczynski');
exports.motyka = require('./similarities/motyka');
exports.pearson = require('./similarities/pearson');
exports.squaredChord = require('./similarities/squaredChord');
exports.tanimoto = require('./similarities/tanimoto');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/similarities.js
 ** module id = 74
 ** module chunks = 0
 **/